export const PRESCRIPTION_PROCESS_VIDEO_SRC = {
  MP4: '/media/videos/rezeptes.mp4',
  WEBM: '/media/videos/rezeptes.webm',
} as const

export type PRESCRIPTION_PROCESS_VIDEO_SRC =
  (typeof PRESCRIPTION_PROCESS_VIDEO_SRC)[keyof typeof PRESCRIPTION_PROCESS_VIDEO_SRC]
